export const resolveInvoiceReference = (invoice = {}, fallback = "") => {
  return invoice?.invoice_number || invoice?.reference || fallback;
};

export const resolveInvoiceTotals = (invoice, rows = []) => {
  const hasLineItems = rows.some((row) =>
    row.item_id ||
    row.ledger ||
    row.description ||
    Number(row.price) ||
    Number(row.discount) ||
    Number(row.vat) ||
    Number(row.wht)
  );

  if (hasLineItems) {
    const subtotal = rows.reduce(
      (sum, row) => sum + (Number(row.qty) * Number(row.price) - Number(row.discount)),
      0
    );
    const totalDiscount = rows.reduce((sum, row) => sum + Number(row.discount || 0), 0);
    const totalVAT = rows.reduce((sum, row) => sum + Number(row.vat || 0), 0);
    const totalWHT = rows.reduce((sum, row) => sum + Number(row.wht || 0), 0);

    return {
      subtotal,
      totalDiscount,
      totalVAT,
      totalWHT,
      grandTotal: subtotal + totalVAT + totalWHT,
    };
  }

  const savedTotals = invoice?.data || invoice || {};
  const subtotal = Number(savedTotals.sub_total) || 0;
  const totalDiscount = Number(savedTotals.total_discount) || 0;
  const totalVAT = Number(savedTotals.total_vat) || 0;
  const totalWHT = Number(savedTotals.total_wht) || 0;

  return {
    subtotal,
    totalDiscount,
    totalVAT,
    totalWHT,
    grandTotal: Number(savedTotals.total_price ?? savedTotals.amount) || subtotal + totalVAT + totalWHT,
  };
};

export const normalizeInvoiceRows = (invoice = {}) => {
  const salesSources = [
    invoice?.sales,
    invoice?.items,
    invoice?.invoice_items,
    invoice?.sale_items,
    invoice?.data?.sales,
    invoice?.data?.items,
  ];
  const sales = salesSources.find((source) => Array.isArray(source) && source.length > 0) || [];

  return sales.map((sale = {}) => {
    const item = sale.item || sale.product || {};
    const qty = Number(sale.quantity ?? sale.qty ?? 1) || 1;
    const savedPrice = sale.price ?? item.price;
    const amount = Number(sale.item_amount ?? sale.amount ?? sale.amount_sold ?? 0) || 0;
    const price = savedPrice == null || savedPrice === ""
      ? amount / qty
      : Number(savedPrice) || 0;
    const discount = Number(sale.discount ?? 0) || 0;
    const vat = Number(sale.vat ?? sale.vat_value ?? 0) || 0;
    const wht = Number(sale.wht ?? sale.wht_value ?? 0) || 0;
    const taxId = sale.tax_id ?? sale.tax?.id ?? (vat > 0 ? 1 : null);
    const whtId = sale.wht_id ?? sale.wht?.id ?? (wht > 0 ? 2 : null);

    return {
      type: 'product',
      ledger: item.name || item.description || sale.ledger || sale.item_name || sale.product_name || sale.name || '',
      description: sale.description || sale.reference || item.description || '',
      userEditedDescription: false,
      qty,
      price,
      discountRate: sale.discount_percentage ?? sale.discountPercentage ?? '',
      discountAmount: sale.discount ?? '',
      discount,
      vatRate: 'Premium',
      vat,
      vatChecked: Boolean(vat),
      tax_id: taxId,
      wht,
      wthChecked: Boolean(wht),
      wht_id: whtId,
      total: Number(sale.amount_sold) || Math.max(0, amount - discount) + vat + wht,
      item_id: item.id ?? sale.item_id ?? sale.product_id ?? null,
      available_quantity: sale.available_quantity ?? undefined,
    };
  });
};
